import React, { createContext, useContext, useState, useEffect } from 'react';

const SiteSettingsContext = createContext();

export const useSiteSettings = () => {
  const context = useContext(SiteSettingsContext);
  if (!context) {
    throw new Error('useSiteSettings must be used within SiteSettingsProvider');
  }
  return context;
};

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    site_title: 'Costa Rica Missions 2025-2026',
    site_subtitle: 'Join us in supporting our mission team as they serve communities in Costa Rica.',
    banner_text: null,
    banner_enabled: false,
    primary_color: '#2563eb',
    accent_color: '#10b981',
    background_gradient_from: '#f0fdf4',
    background_gradient_to: '#dbeafe',
    logo_url: null,
    logo_enabled: false,
    footer_text: null,
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(`${apiUrl}/site-settings`);

      if (response.ok) {
        const data = await response.json();
        setSettings({
          ...data,
          banner_enabled: Boolean(data.banner_enabled),
          logo_enabled: Boolean(data.logo_enabled),
        });
      }
    } catch (error) {
      console.error('Error fetching site settings:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Apply CSS custom properties for colors
  useEffect(() => {
    if (!isLoading) {
      document.documentElement.style.setProperty('--primary-color', settings.primary_color);
      document.documentElement.style.setProperty('--accent-color', settings.accent_color);
      document.documentElement.style.setProperty('--bg-gradient-from', settings.background_gradient_from);
      document.documentElement.style.setProperty('--bg-gradient-to', settings.background_gradient_to);
    }
  }, [settings, isLoading]);

  return (
    <SiteSettingsContext.Provider value={{ settings, isLoading, refreshSettings: fetchSettings }}>
      {children}
    </SiteSettingsContext.Provider>
  );
};
